import * as Yup from 'yup';

export const SignUpSchema = Yup.object().shape({
  password: Yup.string().min(8).required('Please provide a your password'),
});

export type SignUpDataType = Yup.InferType<typeof SignUpSchema>;

type InitialValues = {
  password: string;
};

export const signUpInitialValues: InitialValues = {
  password: '',
};

export interface ISignupData {
  userId?: string;
  base64Secret?: string;
  password: string;
}
